import { useTranslation } from 'react-i18next';
import { IconSearch } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

interface NotFoundProps {
    type: string;
}

export const NotFound = ({ type }: NotFoundProps): JSX.Element => {
    const { t } = useTranslation();

    const getMessage = () => {
        if (type === 'business') return t('business_not_found');
        if (type === 'service') return t('service_not_found');
        if (type === 'reservation') return t('reservation_not_found');
        return t('not_found');
    };

    return (
        <div className="max-w-md mx-auto my-12 p-8 text-center bg-white border border-gray-200/80 rounded-xl shadow-xs flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 mb-5 border border-slate-100">
                <IconSearch size={28} stroke={1.5} />
            </div>
            <h3 className="text-base font-bold text-gray-800 mb-1.5">
                {t('not_found')}
            </h3>
            <p className="text-xs text-gray-500 max-w-xs mb-6 leading-relaxed">
                {getMessage()}
            </p>
        </div>
    );
};
